import axios from '@/libs/api.request'
import config from '@/config'

const baseUrl = config.baseContainerUrl + '/api/v1/'

export const getContainers = (params) => {
  return axios.request({
    url: baseUrl + 'container/',
    params: params,
    method: 'get',
    paramsSerializer: function (params) {
      return require('qs').stringify(params, { indices: false })
    }
  })
}

export const getAllContainers = (nodeId) => {
  return axios.request({
    url: baseUrl + 'container/all/',
    params: {node: nodeId},
    method: 'get'
  })
}

export const detailContainers = (id, nodeId) => {
  return axios.request({
    url: baseUrl + `container/${id}/`,
    params: {node: nodeId},
    method: 'get'
  })
}

export const runContainer = (data) => {
  return axios.request({
    url: baseUrl + 'container/run/',
    data: data,
    method: 'post'
  })
}

export const renameContainer = (containerId, nodeId, name) => {
  return axios.request({
    url: baseUrl + 'container/' + containerId + '/rename/',
    data: {name: name, node: nodeId},
    method: 'post'
  })
}

export const startContainer = (containerId, nodeId) => {
  return axios.request({
    url: baseUrl + 'container/' + containerId + '/start/',
    data: {node: nodeId},
    method: 'post'
  })
}

export const restartContainer = (containerId, nodeId) => {
  return axios.request({
    url: baseUrl + 'container/' + containerId + '/restart/',
    data: {node: nodeId},
    method: 'post'
  })
}

export const getContainerLogs = (containerId, params) => {
  return axios.request({
    url: baseUrl + 'container/' + containerId + '/logs/',
    params: params,
    traditional: true,
    method: 'get'
  })
}

export const getContainerTop = (containerId, params) => {
  return axios.request({
    url: baseUrl + 'container/' + containerId + '/top/',
    params: params,
    method: 'get'
  })
}

export const getContainerInspect = (containerId, params) => {
  return axios.request({
    url: baseUrl + 'container/' + containerId + '/inspect/',
    params: params,
    method: 'get'
  })
}

export const stopContainer = (containerId, nodeId) => {
  return axios.request({
    url: baseUrl + 'container/' + containerId + '/stop/',
    data: {node: nodeId},
    method: 'post'
  })
}

export const pauseContainer = (containerId, nodeId) => {
  return axios.request({
    url: baseUrl + 'container/' + containerId + '/pause/',
    data: {node: nodeId},
    method: 'post'
  })
}

export const unpauseContainer = (containerId, nodeId) => {
  return axios.request({
    url: baseUrl + 'container/' + containerId + '/unpause/',
    data: {node: nodeId},
    method: 'post'
  })
}

export const deleteContainer = (containerId, nodeId) => {
  return axios.request({
    url: baseUrl + 'container/' + containerId + '/',
    data: {node: nodeId},
    method: 'delete'
  })
}

export const BatchActionContainer = (data) => {
  return axios.request({
    url: baseUrl + 'container_batch_action/',
    data: data,
    method: 'post'
  })
}
